import { NmWebElement } from '../../../shared/constants/nm-webs.model';
import { ImageCardItem } from '../../../shared/components';

export class LandingsUtils {
  static mapWebElementsToCards(
    webElements: NmWebElement[] = [],
    altTextSuffix: string = ''
  ): ImageCardItem[] {
    return webElements.map(
      (element, index): ImageCardItem => ({
        imageUrl: element.nmMedia?.url ?? '',
        altText: `Banner ${index + 1} de ${altTextSuffix}`,
        linkUrl: element.redirectUrl || '#',
      })
    );
  }
}
